import { Component, ElementRef } from '@angular/core';

import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/takeUntil';

import { BaseManagedDataWidget } from '../../BaseManagedDataWidget/BaseManagedDataWidget.component';
import { FilterSpec } from '../../../../classes/DataSetFilter';

import {
  CacheDataInfo,
  NameValue,
  ManagedDataReply } from '../../../../interfaces/WidgetInterfaces';
import { DisplayStateService } from '../../../../services/DisplayStateService';
import { AppStateService } from '../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../services/ClientSettingsService';

@Component({
  selector: 'app-generic-base',
  template: `<p>
  generic-base works!
</p>
`,
  styles: [``]
})
export class GenericBaseComponent extends BaseManagedDataWidget {

  cacheDataInfo: CacheDataInfo;

  private searchUpdated: Subject<NameValue> = new Subject<NameValue>();

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }
  onInitialize() {
    super.onInitialize();
  }

  onFilterChange(column, filterExpression) {
    this.searchUpdated.next({name: column, value: filterExpression});
  }

  onManagedDataReply(managedDataReply: ManagedDataReply) {
    this.displayStateService.Log(5, `GenericBaseComponent->${this.Config.name} - onManagedDataReply`);
    this.cacheDataInfo = {
        CacheDate: this.dateFormat(managedDataReply.CacheData.CacheDate),
        MinutesRemaining: managedDataReply.CacheData.MinutesRemaining,
        RetrievedFromCache: managedDataReply.CacheData.RetrievedFromCache,
        key: managedDataReply.CacheData.key,
        Payload: {}
      };
  }

  HandleMessages() {
    this.PostProcessing();
  }

  PostProcessing() { };

  private dateFormat(originalDate: string): string {
    const parts = originalDate.split('_');
    return `${parts[1]}/${parts[2]}/${parts[0]} ${parts[3]}:${parts[4]}:${parts[5]}`;
  }

}
